import axios from 'axios';

export const api = axios.create({
    baseURL: 'https://pfz-cnc.tech/',
    headers: {
      'Content-Type': 'multipart/form-data',
      'X-Requested-With': 'XMLHttpRequest',
    },
  });